import 'bootstrap';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */


import axios from 'axios';
import store from "./store/index.js";
import router from "./router/index.js";
import sendTgErrors from "./debuf.js";
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

const csrfToken = document.head.querySelector('meta[name="csrf-token"]');
if (csrfToken) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
}
const isWebSocketClosedStateError = (error) => {
  const message = String(error?.message || error || '')
  return message.includes('WebSocket is already in CLOSING or CLOSED state')
}
const patchWebSocketSafeMethods = () => {
  if(typeof window === 'undefined' || typeof window.WebSocket !== 'function'){
    return
  }
  const prototype = window.WebSocket.prototype
  if(!prototype || prototype.__quoroomSocketSafePatched){
    return
  }
  const originalSend = prototype.send
  const originalClose = prototype.close
  if(typeof originalSend === 'function'){
    prototype.send = function (...args) {
      try{
        return originalSend.apply(this, args)
      }catch (error){
        if(isWebSocketClosedStateError(error)){
          return undefined
        }
        throw error
      }
    }
  }
  if(typeof originalClose === 'function'){
    prototype.close = function (...args) {
      try{
        return originalClose.apply(this, args)
      }catch (error){
        if(isWebSocketClosedStateError(error)){
          return undefined
        }
        throw error
      }
    }
  }
  Object.defineProperty(prototype, '__quoroomSocketSafePatched', {
    value: true,
    configurable: false,
    enumerable: false,
    writable: false
  })
}
patchWebSocketSafeMethods()

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
const isTokenExpired = () => {
  const raw = localStorage.getItem('x_xsrf_token_time')
  if(!raw){
    return false
  }
  const time = new Date(raw).getTime()
  if(Number.isNaN(time)){
    return true
  }
  return time < Date.now()
}

const DEV_USER_ID = 9
const isInsideIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
const hasSsoTokenInLocation = () => {
  try {
    const params = new URLSearchParams(window.location.search || '')
    const token = params.get('token')
    return typeof token === 'string' && token.trim() !== ''
  } catch (e) {
    return false
  }
}

const devAutoLogin = async () => {
  if (!isLocalhost) return
  if (isInsideIframe()) return
  if (window.location.pathname.startsWith('/sso/login')) return
  if (hasSsoTokenInLocation()) return
  const token = localStorage.getItem('x_xsrf_token')
  const tokenExpired = token && isTokenExpired()
  const storedUserRaw = localStorage.getItem('user_info')
  let storedUserId = null
  if (storedUserRaw) {
    try {
      storedUserId = JSON.parse(storedUserRaw)?.user_id ?? null
    } catch (e) {
      storedUserId = null
    }
  }
  if (token && !tokenExpired && storedUserId && Number(storedUserId) !== DEV_USER_ID) {
    localStorage.removeItem('x_xsrf_token')
    localStorage.removeItem('x_xsrf_token_time')
    localStorage.removeItem('user_info')
  }

  const refreshedToken = localStorage.getItem('x_xsrf_token')
  const refreshedExpired = refreshedToken && isTokenExpired()
  if (refreshedToken && !refreshedExpired) {
    if (!localStorage.getItem('user_info')) {
      store.commit('auth/setUser')
    }
    return
  }
  if (refreshedExpired) {
    localStorage.removeItem('x_xsrf_token')
    localStorage.removeItem('x_xsrf_token_time')
    localStorage.removeItem('user_info')
  }

  try {
    const res = await fetch('/api/dev/token', {
      headers: {
        accept: 'application/json',
      },
    })

    if (!res.ok) return

    const ct = res.headers.get('content-type') || ''
    if (!ct.includes('application/json')) return

    const data = await res.json()

    if (!data?.token || !data?.expires_in) return

    const expiresAt = new Date()
    const ttlMinutes = Number(data.expires_in)
    if (!Number.isNaN(ttlMinutes) && ttlMinutes > 0) {
      expiresAt.setSeconds(expiresAt.getSeconds() + (ttlMinutes * 60))
    }

    localStorage.setItem('x_xsrf_token', data.token)
    localStorage.setItem('x_xsrf_token_time', expiresAt.toString())

    if (data.user && typeof data.user === 'object') {
      localStorage.setItem('user_info', JSON.stringify(data.user))
    }

    store.commit('auth/setUser')

    if (window.location.pathname === '/') {
      window.location.assign('/rooms')
    }
  } catch (e) {
  }
}

window.__devAutoLoginPromise = devAutoLogin()
const parseBearerToken = (headerValue) => {
  if(typeof headerValue !== 'string'){
    return ''
  }
  return headerValue.startsWith('Bearer ') ? headerValue.slice(7) : ''
}
const authFailureByToken = new Map()
const incrementAuthFailure = (token) => {
  if(!token){
    return 0
  }
  const nextValue = (authFailureByToken.get(token) || 0) + 1
  authFailureByToken.set(token, nextValue)
  return nextValue
}
const resetAuthFailure = (token) => {
  if(!token){
    return
  }
  authFailureByToken.delete(token)
}

window.axios.interceptors.request.use(config =>{
  const skipLoader = config?.skipLoader === true
  if(!skipLoader && document.querySelector('.loader')){
    document.querySelector('.loader').classList.add('active')
  }
  if(!config.headers){
    config.headers = {}
  }

  if(localStorage.getItem('x_xsrf_token')){
    const token = localStorage.getItem('x_xsrf_token');
    const currentAuthHeader = config?.headers?.Authorization || config?.headers?.authorization
    if(!currentAuthHeader){
      config.headers.Authorization =  `Bearer ${token}`;
      config._authTokenAtRequest = token
    }else{
      config._authTokenAtRequest = parseBearerToken(currentAuthHeader)
    }
  }else{
    const currentAuthHeader = config?.headers?.Authorization || config?.headers?.authorization
    config._authTokenAtRequest = parseBearerToken(currentAuthHeader)
  }
  return config;
})
window.axios.interceptors.response.use(config =>{
  const skipLoader = config?.config?.skipLoader === true
  if(!skipLoader && document.querySelector('.loader')){
    document.querySelector('.loader').classList.remove('active')
  }
  const responseToken = typeof config?.config?._authTokenAtRequest === 'string' ? config.config._authTokenAtRequest : ''
  if(responseToken){
    resetAuthFailure(responseToken)
  }

  if(localStorage.getItem('x_xsrf_token')){
    const token = localStorage.getItem('x_xsrf_token');
    config.headers.Authorization =  `Bearer ${token}`;
  }
  return config;
}, async err =>{
  const skipLoader = err?.config?.skipLoader === true
  if(!skipLoader && document.querySelector('.loader')){
    document.querySelector('.loader').classList.remove('active')
  }

  const response = err?.response
  const url = err?.config?.url

  if (url === '/debug') {
    return response ?? { status: 0, data: null }
  }

  const status = response?.status

  if (!status) {
    return { status: 0, data: null }
  }

  if(status === 401 || status === 419){
    const requestToken = typeof err?.config?._authTokenAtRequest === 'string' ? err.config._authTokenAtRequest : ''
    const currentToken = localStorage.getItem('x_xsrf_token') || ''
    const isAuthBootstrapRequest = err?.config?.authBootstrapRequest === true
    if(!requestToken){
      return response
    }
    if(currentToken && requestToken !== currentToken){
      return response
    }
    if(isAuthBootstrapRequest){
      return response
    }
    const failCount = incrementAuthFailure(requestToken)
    if(failCount < 2){
      const recoveredFast = await store.dispatch('auth/bootstrapUserWithRetry', { attempts: 2, delayMs: 200 }).catch(() => false)
      if(recoveredFast){
        resetAuthFailure(requestToken)
      }
      return response
    }
    const recovered = await store.dispatch('auth/bootstrapUserWithRetry', { attempts: 3, delayMs: 250 }).catch(() => false)
    if(recovered){
      resetAuthFailure(requestToken)
      return response
    }
    sendTgErrors(err)
    sendTgErrors(localStorage.getItem('x_xsrf_token'))
    sendTgErrors(localStorage.getItem('user_info'))
    if(currentToken && requestToken === currentToken){
      resetAuthFailure(requestToken)
      localStorage.removeItem('x_xsrf_token')
      localStorage.removeItem('x_xsrf_token_time')
      localStorage.removeItem('user_info')
      store.commit('auth/clearUser')
      router.push({ name: 'home' })
    }
  }else if(status === 422){
    store.commit('error/setError', response.data)
  }

  return response;
})

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
